// extracted by mini-css-extract-plugin
export default {"post_detail":"PostDetail_post_detail__4x4Pb","createdBy":"PostDetail_createdBy__2lURA","tags":"PostDetail_tags__7OOVV"};